import { DashboardAPI } from "utils/api";

export const importH2kFile = async (formData, data = {}) => {
    const { name = "", notes = "", templateID = "", templateName = "", parentFolderId = "" } = data;

    return DashboardAPI({
        method: "POST",
        url: "/createHouseModelFromFile",
        file: formData,
        headers: {
            "content-type": "multipart/form-data",
        },
    }).catch((err) => console.log(err.message));
};

export const importCodeLibFile = async (formData) => {
    return DashboardAPI({
        method: "POST",
        url: "/importCodeLibFromFile",
        file: formData,
        headers: {
            "content-type": "multipart/form-data",
        },
    }).catch((err) => console.log(err.message));
};

export const exportH2kFile = async ({
    modelId,
    returnType,
    h2kVersion,
    upgradePackage,
    appendResults,
    applyUpgradesToBase = false,
    excludeClientData = false,
    infoItemsToAdd = [],
}) => {
    return DashboardAPI({
        method: "POST",
        url: "/getHouseModel",
        data: {
            id: modelId,
            returnType: returnType ? returnType : "XML",
            h2kVersion: h2kVersion ? h2kVersion : "v11-9",
            upgradePackage: upgradePackage ? upgradePackage : "",
            appendResults: appendResults ? appendResults : false,
            applyUpgradesToBase,
            excludeClientData,
            infoItemsToAdd,
        },
    })
        .then((data) => data.data)
        .catch((err) => console.log(err.message));
};

export const exportH2kFileWithResults = async ({ modelId, userId, packages = [], applyUpgradesToBase = false }) => {
    return DashboardAPI({
        method: "POST",
        url: "/getHouseModelWithResults",
        data: {
            modelId,
            userId,
            packages,
            applyUpgradesToBase,
        },
    })
        .then((data) => data.data)
        .catch((err) => console.log(err.message));
};

export const validateH2kExport = async ({ modelId, h2kVersion, upgradePackage, isSimulation = false }) => {
    return DashboardAPI({
        method: "POST",
        url: "/validateH2kExport",
        data: {
            id: modelId,
            h2kVersion: h2kVersion ? h2kVersion : "v11-9",
            upgradePackage: upgradePackage ? upgradePackage : "",
            isSimulation,
        },
    })
        .then((data) => data.data)
        .catch((err) => console.log(err.message));
};

export const sendDataToBKC = async ({ modelId, modelData }) => {
    return DashboardAPI({
        method: "POST",
        url: "/sendDataToBKC",
        data: {
            modelId,
            modelData,
        },
    })
        .then((data) => {
            // Return the response data which contains success/error info
            return data.data;
        })
        .catch((err) => {
            // Return error information in a format that can be checked in the component
            if (err.response && err.response.data) {
                // Server responded with error data
                return err.response.data;
            }
            // Network error or other exception
            throw err;
        });
};

export const pushCodeLibraryToBKC = async ({ codeRefs = [] }) => {
    return DashboardAPI({
        method: "POST",
        url: "/pushCodeLibraryToBKC",
        data: {
            pushEntireCodeLibrary: false,
            codeRefs,
        },
    })
        .then((data) => data.data)
        .catch((err) => {
            if (err.response && err.response.data) {
                return err.response.data;
            }
            throw err;
        });
};
